import React from "react";
import env from "env";
import { useRouter } from "components";
import { useGet, usePost } from "components";
import { ErrorPopup } from "components";
import { getStoreEditModel } from "./storeEditFormModel";
import { Redirect, Link } from "react-router-dom";
import { useForm } from "form";
import { Button, ErrorMessage } from "components";
import { ImageSelector } from './imageSelector';
//import utils from 'utils';

export function StoreEdit(props) {
  const { query } = useRouter();
  const get = useGet();

  const storeCode = query.id || "";

  React.useEffect(() => {
    get.send(env.apiBase + `/api/storeAdmin/getStore/${storeCode}`);
    // eslint-disable-next-line
  }, []);

  if (get.loading()) {
    return <div>Loading...</div>;
  } else if (get.hasErrors()) {
    return <ErrorPopup title="Loading Error" errors={get.errors} />;
  }

  const data = get.response;
  const model = getStoreEditModel(data);

  return <StoreEditForm model={model} data={data} storeCode={storeCode} />;
}

function StoreEditForm({ model, data, storeCode }) {
  const form = useForm(model, {});
  const post = usePost();

  const render = (name) => form.renderControl(name);

  function save(e) {
    form.validateForm(e, () => {
      const formValue = form.getValue();
      const value = { 
        ...formValue, 
        orgstoreCode: storeCode,
        // Convert iconPath array to string (take first image URL)
        iconPath: formValue.iconPath && formValue.iconPath.length > 0 ? formValue.iconPath[0].imageUrl : ""
      };

      console.log(value);

      post.send(env.apiBase + "/api/storeAdmin/saveStore", value);
    });
  }

  function remove(e) {
    if (!window.confirm("Delete this??")) return;
    post.send(env.apiBase + "/api/storeAdmin/removeStore", { storeCode: storeCode });
  }

  if (post.status === "done") {
    return <Redirect to={`/admin/stores`} />;
  }

  return (
    <div className="editor productEditor">
      <h1>Store Edit</h1>

      <section>
        <div className="row">
          <div className="col-md-9">{render("storeName")}</div>
          <div className="col-md-3">{render("storeCode")}</div>
        </div>
        <hr />

        <div className="row">
          <div className="col-md-6">{render("buyOnline")}</div>
        </div>

        <div className="row">
          <div className="col-md-6">{render("seq")}</div>
          <div className="col-md-6">{render("storeUrl")}</div>
        </div>
        <hr />
        <div className="row">
          <div className="col-md-6">
            <label className="label">Icon Path</label>
            <ImageSelector form={form} fieldName="iconPath" data={data} />
          </div>
          <div className="col-md-6">{render("mailchimpName")}</div>
        </div>

        <div className="row">
          <div className="col-12 actions">
            <ErrorMessage errors={form.errors} />
            <ErrorMessage errors={post.errors} />
            <Button onClick={save} status={form.status}>
              Save
            </Button>
            {storeCode && (
              <Button onClick={remove} status={form.status} btnStyle="outline-primary">
                Delete
              </Button>
            )}
            <Link className="btn btn-outline-dark" to="/admin/stores">
              Cancel
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
